import React from 'react';
import { ScrollView, View, StyleSheet } from 'react-native';
import { useMarginBottom } from 'hooks/useMarginBottom';
import KeyboardSettingsRow from './KeyboardSettingsRow';
import { isDesktopOrWeb } from '../../../../constants';
const items = [
    {
        title: 'Default',
        filter: 'DEFAULT',
        subTitle: 'AND across filter types (e.g. category AND tag), OR within a type (e.g. Bills OR Business)',
    },
    {
        title: 'Match all',
        filter: 'AND',
        subTitle: 'AND across all conditions',
    },
    {
        title: 'Match any',
        filter: 'OR',
        subTitle: 'OR across all conditions',
    },
];
const KeyboardSettings = ({ onChangeSettingsFilter, contentContainerStyle, settingsFilter }) => {
    const scrollViewStyle = useMarginBottom('paddingBottom', undefined, styles.scrollView);
    return (<View style={contentContainerStyle}>
      <ScrollView contentContainerStyle={scrollViewStyle}>
        {items.map((item) => (<KeyboardSettingsRow key={item.title} title={item.title} filter={item.filter} activeSettingsFilter={settingsFilter} subTitle={item.subTitle} onPress={onChangeSettingsFilter}/>))}
      </ScrollView>
    </View>);
};
const styles = StyleSheet.create({
    scrollView: {
        ...(isDesktopOrWeb && {
            padding: 8,
        }),
    },
});
export default KeyboardSettings;
